export const ARTIFACT_BADGE_LABEL = 'Artifact'
